import styled from 'styled-components';
import { useLocation, Link } from 'react-router-dom';
import { useState } from 'react';
import AddUserModal from './AddUserModal';
const HeaderNav = styled.header`
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #f2f2f2;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 62px;
`;
const HeaderInner = styled.div`
  width: 100%;
  margin : 0 auto;
  max-width: 1400px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative; // Add this
`;

const TitleHead = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  color: #193046ff;
  font-size: 1.20rem;
`;
const IconLogo = styled.img`
  width: 26px;      /* Adjust as needed */
  height: 26px;     /* Maintain aspect ratio if you want */
  object-fit: contain;
`;

const NavActions = styled.div`
  display: flex;
  align-items: center;
  gap: 28px;
  font-size: 1rem;
`;

const WelcomeUser = styled.div`
  color: #233e58;
  font-weight: 400;
  font-size: 1rem;

  strong {
    font-weight: 600;
    color: #21395c;
  }
  span.role {
    background: #f1f5ff;
    border-radius: 6px;
    color: #246CC6 ;
    font-size: 0.9rem;
    padding: 2px 6px;
    margin-left: 3px;
    font-weight: 500;
  }
`;

const NavLink = styled.a`
  background : '#fff';
  color: #21395c;
  font-weight: 600;
  text-decoration: none;
  padding: 5px 12px;
  border-radius: 7px;
  transition: background 0.2s;

  &:hover {
    background: #21395c;
    color : #fff
  }
`;

const NavButton = styled.button`
  color: #246cc6;
  font-weight: 500;
  background: transparent;
  border: none;
  padding: 5px 12px;
  border-radius: 7px;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #f2f6fe;
  }
`;
const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  padding: 8px 0;
  min-width: 180px;
  display: ${(props) => (props.open ? 'block' : 'none')};
  z-index: 100;
`;

const DropdownItem = styled.a`
  display: block;
  padding: 8px 16px;
  color: #193046ff;
  font-weight: 700;
  text-decoration: none;
  transition: background 0.2s;

  &:hover {
    background: #193046ff;
    color: #fff;
  }
`;

export default function MainHeader() {
    const [dropdownOpen, setDropdownOpen] = useState(false);

  const [showModal,setShowModal] = useState(false)
  const location = useLocation();
  const userData = {
    user : JSON.parse(localStorage.getItem('user')),
    token : localStorage.getItem('access_token')
  }

  const isAdmin = userData.user.roles.role_name == "SUPER_ADMIN"

   console.log("Ashmin testing for Admin :",isAdmin)

  // Determine link label and target url
  const isCashflowPage = location.pathname === '/cashflow';
  const navLabel = !isCashflowPage ? 'Add Entry' : 'Dashboard';
  const navLink = !isCashflowPage ? '/cashflow' : '/dashboard';
  const hostname = window.location.hostname;
const isInventoryDomain = hostname === 'inventory.fescafe.in';
const isRecordsDomain = hostname === 'records.fescafe.in';
  return (
    <HeaderNav>
      <HeaderInner style={{width: '100%'}}>
        <TitleHead>
  <IconLogo src="/images/feslogo.png" alt="FES Cash Flow Logo" />
          <span className='brandTitle'>FES Cash Flow</span>
        </TitleHead>
        <NavActions>
          <WelcomeUser>
            Welcome, <strong>{userData.user.username}</strong>
            {isAdmin && <span className="role">admin</span>}
          </WelcomeUser>
{/* Link toggles text and href based on current page */}
         {isAdmin && isRecordsDomain && <NavLink href="/cashflow" >
            Add Entry
          </NavLink>}
          {isAdmin && isRecordsDomain && <NavLink href="/dashboard" >
            Dashboard
          </NavLink>}
          <>
           {/* <NavLink onClick={() => setShowModal(true)}>Add User</NavLink> */}
      <AddUserModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onUserAdded={() => {
          console.log('User added!');
        }}
      />
          </>
                                {/* <NavLink href="/users">Users</NavLink>
                    <NavLink href="/stores">Stores</NavLink> */}

                    <NavLink onClick={()=> localStorage.clear()} href="/">Sign Out</NavLink>
        
       {userData.user.roles.role_name == "SUPER_ADMIN" && <NavButton onClick={() => setDropdownOpen((prev) => !prev)}>
             ▼
      

<DropdownMenu open={dropdownOpen}>
  {/* Always allow these */}
   {isRecordsDomain && (
    <>
  <DropdownItem href="/users">Users</DropdownItem>
  <DropdownItem href="/stores">Stores</DropdownItem>
  </>
  )}
  
  {/* Inventory domain: show ONLY inventory routes */}
  {isInventoryDomain && (
    <>
      <DropdownItem href="/inventory/products">Inventory Products</DropdownItem>
      <DropdownItem href="/inventory/entries">Inventory Entries</DropdownItem>
      <DropdownItem href="/categories">Inventory Categories</DropdownItem>
    </>
  )}

  {/* Records domain: hide inventory routes, show others */}
  {isRecordsDomain && (
    <>
      <DropdownItem href="/reports">Reports</DropdownItem>
      <DropdownItem href="/settings">Settings</DropdownItem>
    </>
  )}

  {/* For other domains, show all */}
  {!isInventoryDomain && !isRecordsDomain && (
    <>
    <DropdownItem href="/users">Users</DropdownItem>
  <DropdownItem href="/stores">Stores</DropdownItem>
      <DropdownItem href="/inventory/products">Inventory Products</DropdownItem>
      <DropdownItem href="/inventory/entries">Inventory Entries</DropdownItem>
      <DropdownItem href="/categories">Inventory Categories</DropdownItem>
      <DropdownItem href="/reports">Reports</DropdownItem>
      <DropdownItem href="/settings">Settings</DropdownItem>
    </>
  )}
</DropdownMenu>

          </NavButton>}
        </NavActions>
      </HeaderInner>
    </HeaderNav>
  );
}
